import axios from 'axios';
import { apiGetError } from 'constants/apiRouting';
import { handleErrors } from '../../utils/api';

export const ON_FAILED_REQUEST = 'ON_FAILED_REQUEST';
export const RESET_ERRORS = 'RESET_ERRORS';


export const triggerErrorCode = code => async (dispatch) => {
  try {
    await axios.get(apiGetError(code), { withCredentials: true });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};
